export default "__VITE_PUBLIC_ASSET__0acbff45__"